import React from 'react';
import { hebrewStrings } from './strings/hebrewStrings';
import './App.css';

function SupportPageHe() {
  const strings = hebrewStrings;
  
  return (
    <div className="rtl">
      {/* Hero Section */}
      <section className="hero-modern">
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="app-logo">
                <div className="logo-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <rect width="48" height="48" rx="12" fill="url(#gradient1)"/>
                    <path d="M12 20h24v8H12v-8z" fill="white" opacity="0.9"/>
                    <circle cx="16" cy="24" r="2" fill="white"/>
                    <circle cx="32" cy="24" r="2" fill="white"/>
                    <defs>
                      <linearGradient id="gradient1" x1="0" y1="0" x2="48" y2="48">
                        <stop stopColor="#6366F1"/>
                        <stop offset="1" stopColor="#4C1D95"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="logo-text">
                  <h1>{strings.hero.appName}</h1>
                  <span>{strings.hero.appSubtitle}</span>
                </div>
              </div>
              <h2>{strings.hero.title}</h2>
              <p>{strings.hero.description}</p>
              <div className="hero-badges">
                <div className="badge-modern">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2L13 8h5l-4 4 1.5 6L10 15l-5.5 3L6 12l-4-4h5l3-6z" fill="currentColor"/>
                  </svg>
                  {strings.hero.badges.available}
                </div>
                <div className="badge-modern secondary">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 9V7a1 1 0 112 0v2a1 1 0 11-2 0zm1 4a1 1 0 100-2 1 1 0 000 2z" fill="currentColor"/>
                  </svg>
                  {strings.hero.badges.free}
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="phone-mockup">
                <div className="phone-screen">
                  <div className="app-preview">
                    <div className="preview-header"></div>
                    <div className="preview-map"></div>
                    <div className="preview-card"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-modern">
        <div className="container">
          <div className="section-header">
            <h3>{strings.features.sectionTitle}</h3>
            <p>{strings.features.sectionDescription}</p>
          </div>
          <div className="features-grid-modern">
            <div className="feature-card">
              <div className="feature-icon-modern">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 8v8l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h4>{strings.features.smartRecommendations.title}</h4>
              <p>{strings.features.smartRecommendations.description}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-modern accessibility">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4a4 4 0 100 8 4 4 0 000-8zM12 14a2 2 0 00-2 2v8a2 2 0 104 0v-6h4v6a2 2 0 104 0v-8a2 2 0 00-2-2h-8z" fill="currentColor"/>
                </svg>
              </div>
              <h4>{strings.features.accessibility.title}</h4>
              <p>{strings.features.accessibility.description}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-modern">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M4 8a4 4 0 018 0v16a4 4 0 01-8 0V8zM20 8a4 4 0 018 0v16a4 4 0 01-8 0V8z" fill="currentColor"/>
                </svg>
              </div>
              <h4>{strings.features.bilingual.title}</h4>
              <p>{strings.features.bilingual.description}</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-modern">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 8v8h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h4>{strings.features.realtime.title}</h4>
              <p>{strings.features.realtime.description}</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-modern">
        <div className="container">
          <div className="section-header">
            <h3>{strings.faq.sectionTitle}</h3>
            <p>{strings.faq.sectionDescription}</p>
          </div>
          <div className="faq-grid">
            <div className="faq-card">
              <div className="faq-question">
                <h4>{strings.faq.questions.coverage.question}</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>{strings.faq.questions.coverage.answer}</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>{strings.faq.questions.algorithm.question}</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>{strings.faq.questions.algorithm.answer}</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>{strings.faq.questions.location.question}</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>{strings.faq.questions.location.answer}</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>{strings.faq.questions.offline.question}</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>{strings.faq.questions.offline.answer}</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>{strings.faq.questions.pricing.question}</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>{strings.faq.questions.pricing.answer}</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>{strings.faq.questions.accuracy.question}</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>{strings.faq.questions.accuracy.answer}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-modern">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-content">
              <div className="section-header">
                <h3>{strings.contact.sectionTitle}</h3>
                <p>{strings.contact.sectionDescription}</p>
              </div>
              <div className="contact-grid">
                <div className="contact-card">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h4>{strings.contact.support.title}</h4>
                  <p>{strings.contact.support.description}</p>
                  <a href={`mailto:${strings.contact.support.email}`} className="contact-link-modern">
                    {strings.contact.support.email}
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8h10m0 0l-3-3m3 3l-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
                <div className="contact-card">
                  <div className="contact-icon feedback">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h4>{strings.contact.feedback.title}</h4>
                  <p>{strings.contact.feedback.description}</p>
                  <a href={`mailto:${strings.contact.feedback.email}`} className="contact-link-modern">
                    {strings.contact.feedback.email}
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8h10m0 0l-3-3m3 3l-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="response-time">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M10 6v4l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <span>{strings.contact.responseTime}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer-modern">
        <div className="container">
          <div className="footer-content-modern">
            <div className="footer-brand">
              <div className="footer-logo">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <rect width="32" height="32" rx="8" fill="url(#footerGradient)"/>
                  <path d="M8 13h16v6H8v-6z" fill="white" opacity="0.9"/>
                  <circle cx="11" cy="16" r="1.5" fill="white"/>
                  <circle cx="21" cy="16" r="1.5" fill="white"/>
                  <defs>
                    <linearGradient id="footerGradient" x1="0" y1="0" x2="32" y2="32">
                      <stop stopColor="#6366F1"/>
                      <stop offset="1" stopColor="#4C1D95"/>
                    </linearGradient>
                  </defs>
                </svg>
                <span>{strings.footer.appName}</span>
              </div>
              <p>{strings.footer.description}</p>
            </div>
            <div className="footer-stats">
              <div className="stat">
                <strong>34</strong>
                <span>{strings.footer.stats.stations}</span>
              </div>
              <div className="stat">
                <strong>6</strong>
                <span>{strings.footer.stats.cities}</span>
              </div>
              <div className="stat">
                <strong>65+</strong>
                <span>{strings.footer.stats.exits}</span>
              </div>
            </div>
          </div>
          <div className="footer-bottom-modern">
            <p>&copy; 2025 Where2Exit. {strings.footer.copyright}</p>
            <div className="footer-version">
              <span>{strings.footer.version}</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default SupportPageHe;